module.exports = __webpack_public_path__ + "1c92bac1.png";